import { Leaf } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

const Marquee = () => {
  const { t } = useLanguage();

  return (
    <div
      data-testid="expertise-marquee"
      className="relative overflow-hidden border-y border-emerald-500/15 bg-[#0F2117] py-5"
    >
      <div className="animate-eco-marquee flex w-max">
        {[...t.marquee, ...t.marquee].map((item, i) => (
          <span
            key={`${item}-${i}`}
            className="flex items-center whitespace-nowrap font-mono-tech text-xs uppercase tracking-[0.3em] text-emerald-300/70 sm:text-sm"
          >
            <span className="px-8">{item}</span>
            <Leaf className="h-4 w-4 shrink-0 text-emerald-500/60" />
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
